import React from "react";
import PropTypes from "prop-types";
import { Box, Chip, Typography, makeStyles } from "@material-ui/core";
import { grayColor } from "assets/jss/material-dashboard-pro-react.js";

const useStyles = makeStyles((theme) => ({
  card: {
    cursor: "pointer",
    border: `1px solid ${grayColor[8]}`,
    borderRadius: "6px",
    padding: theme.spacing(2, 1.5),
    backgroundColor: "#ffffff",
    transition: "all 0.2s ease-in-out",
    textAlign: "center",
    minWidth: "180px",
    "&:hover": {
      transform: "translateY(-2px)",
      boxShadow: "0 4px 12px rgba(0,0,0,0.1)",
      borderColor: (props) => props.clientColor || "#1976d2",
    },
    "&.selected": {
      borderColor: (props) => props.clientColor || "#1976d2",
      borderWidth: "2px",
      boxShadow: "0 2px 8px rgba(0,0,0,0.15)",
    },
    "&.disabled": {
      cursor: "not-allowed",
      opacity: 0.5,
      backgroundColor: "#f5f5f5",
      "&:hover": {
        transform: "none",
        boxShadow: "none",
        borderColor: grayColor[8],
      },
    },
  },
  title: {
    fontSize: "0.95rem",
    fontWeight: "500",
    color: "#333",
    marginBottom: theme.spacing(1),
  },
  badge: {
    fontSize: "0.75rem",
    height: "24px",
    borderRadius: "12px",
    marginTop: "8px",
  },
}));

export default function DimensionCard({
  label,
  selectionCount,
  selectionLabel,
  isSelected,
  onClick,
  clientColor,
  disabled = false,
}) {
  const classes = useStyles({ clientColor });

  const hasSelections = selectionCount > 0;
  const displayLabel =
    selectionLabel ||
    (hasSelections ? `${selectionCount} selected` : "0 selected");

  return (
    <Box
      className={`${classes.card} ${isSelected ? "selected" : ""} ${disabled ? "disabled" : ""}`}
      onClick={disabled ? undefined : onClick}
    >
      <Typography className={classes.title}>{label}</Typography>
      <Chip
        label={hasSelections ? `✓ ${displayLabel}` : displayLabel}
        size="small"
        className={classes.badge}
        style={{
          backgroundColor: hasSelections ? clientColor || "#1976d2" : "#e0e0e0",
          color: hasSelections ? "#fff" : "#666",
        }}
      />
    </Box>
  );
}

DimensionCard.propTypes = {
  label: PropTypes.string.isRequired,
  selectionCount: PropTypes.number.isRequired,
  selectionLabel: PropTypes.string,
  isSelected: PropTypes.bool.isRequired,
  onClick: PropTypes.func.isRequired,
  clientColor: PropTypes.string,
  disabled: PropTypes.bool,
};
